import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';

import { SliderToggleInputComponent } from '../form-input/slider-toggle-input/slider-toggle-input.component';

import { ButtonDirective } from 'shared/directive/button.directive';
import { checkCookie, setCookie, setGoogleAnalyticsCookies } from 'shared/tools/manage-cookie';
import { WINDOW } from 'shared/tools/window-provider';

export const COOKIE_POLICY_COOKIE_NAME = 'cookie-policy';

@Component({
	selector: 'app-cookie-consent',
	templateUrl: './cookie-consent.component.html',
	styleUrl: './cookie-consent.component.scss',
	standalone: true,
	imports: [
		MatTabsModule,
		FormsModule,
		ReactiveFormsModule,
		SliderToggleInputComponent,
		MatButtonModule,
		ButtonDirective,
		TranslateModule,
	],
})
export class CookieConsentComponent {
	public showCookieConsent: boolean;
	public isGoogleAnalyticsChecked = true;
	public isGoogleAnalyticsEnabled: string;
	public domain: string;
	public form: FormGroup;

	constructor(
		@Inject(WINDOW) private window: Window,
		private fb: FormBuilder
	) {
		this.showCookieConsent = !checkCookie(COOKIE_POLICY_COOKIE_NAME);
		this.domain = this.window.location.hostname;
		this.form = this.fb.group({
			default: true,
			googleAnalytics: true,
		});
		this.isGoogleAnalyticsEnabled = '$PROJECT_GOOGLE_ANALYTICS_ENABLED';
	}

	public acceptCookies(acceptAll = false) {
		if ((acceptAll || this.form.value.googleAnalytics) && this.isGoogleAnalyticsEnabled === 'true') {
			setGoogleAnalyticsCookies();
		}
		setCookie(COOKIE_POLICY_COOKIE_NAME, 'accepted', 365, undefined, this.domain);
		this.closeCookieConsent();
	}

	public closeCookieConsent() {
		this.showCookieConsent = false;
	}

	changeGA(event: boolean) {
		this.form.value.googleAnalytics = event;
		this.isGoogleAnalyticsChecked = event;
	}
}
